<p-dialog appDialogoPadrao="pi pi-check-square" descricao="Escolha o assunto na lista." [header]="header()" [visible]="visivel()" (visibleChange)="$event ? null : fechar()" [style]="{ width: '760px', maxWidth: '96vw' }" [closeOnEscape]="true">
    <div class="assunto-modal-body">
        @if (buscando()) {
            <div class="flex items-center justify-center gap-2 py-10 text-surface-500">
                <i class="pi pi-spin pi-spinner text-xl" aria-hidden="true"></i>
                <span class="text-sm">Carregando assuntos...</span>
            </div>
        } @else {
            <p-tree
                [value]="assuntoTree()"
                [filter]="true"
                filterMode="lenient"
                filterPlaceholder="Pesquisar por código ou descrição..."
                selectionMode="single"
                [metaKeySelection]="false"
                [selection]="selecionado()"
                (onNodeSelect)="selecionado.set($event.node)"
                (onNodeUnselect)="selecionado.set(null)"
                scrollHeight="400px"
                styleClass="assunto-modal-tree w-full"
            >
                <ng-template pTemplate="default" let-node>
                    <div class="tree-node-row">
                        <code class="tree-node-code">{{ node.data?.idAssunto }}</code>
                        <span class="tree-node-desc">{{ node.data?.dsAssunto }}</span>
                    </div>
                </ng-template>
            </p-tree>
            @if (assuntoTree().length === 0) {
                <div class="flex flex-col items-center gap-2 py-10 text-surface-400">
                    <i class="pi pi-inbox text-3xl" aria-hidden="true"></i>
                    <span class="text-sm">Nenhum assunto encontrado.</span>
                </div>
            }
        }
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" icon="pi pi-times" text (click)="fechar()" ariaLabel="Cancelar seleção de assunto" />
        <p-button label="Selecionar" icon="pi pi-check" [disabled]="!selecionado()" (click)="confirmarSelecao()" ariaLabel="Confirmar assunto selecionado" />
    </ng-template>
</p-dialog>
